import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "alert-hint mb-3"
};
const _hoisted_2 = {
  class: "rounded-lg bgColor file-list"
};
const _hoisted_3 = {
  class: "flex justify-between pl-4 pr-4"
};
const _hoisted_4 = {
  key: 0,
  class: "absolute -top-1 -left-1"
};
const _hoisted_5 = {
  class: "fileItem"
};
const _hoisted_6 = {
  class: "title flex-wrap items-center"
};
const _hoisted_7 = {
  class: "truncate flex-1"
};
const _hoisted_8 = {
  key: 0,
  class: "desc w-full"
};
const _hoisted_9 = {
  key: 1,
  class: "desc w-full"
};
const _hoisted_10 = {
  key: 0,
  class: "media-list flex flex-wrap gap-2"
};
const _hoisted_11 = {
  key: 1,
  class: "media-list flex flex-wrap gap-2"
};
const _hoisted_12 = {
  key: 0,
  class: "mt-2 flex flex-wrap gap-2"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1,
  class: "mt-2 flex flex-wrap gap-2"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "rounded-lg bgColor text-[#86909C] p-4 mt-3"
};
const _hoisted_17 = {
  class: "text-[#1D2129]"
};
import { ref, onMounted, computed, inject } from 'vue';
import { Edit } from '@element-plus/icons-vue';
import useAppStore from '@views/app.store';
import { getOrdinaryMediaType, getSelfMediaType } from '@/views/main/api/media';
import useMedia from '@/views/main/components/media/hooks/useMedia';
import DraggableWrapper from '@views/home/components/preview-dialog/DraggableWrapper.vue';
import Tab2Dialog from './Tab2Dialog.vue';
import ArticleHandle from '../components/ArticleHandle.vue';
export default /*@__PURE__*/Object.assign({
  name: 'MediaCreateTab2'
}, {
  __name: 'Tab2',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['refresh'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const appStore = useAppStore();
    const useCount = computed(() => {
      let count = 0;
      availableFiles.value.forEach(file => {
        if (props.data.label == '臻选媒体') {
          if (file.selectedMediaIds) {
            count += file.selectedMediaIds.length;
          }
        } else if (props.data.label == '自媒体') {
          if (file.selfMediaIds) {
            count += file.selfMediaIds.length;
          }
        }
      });
      return count * 20;
    });
    const mediaOptions = ref([]);
    const mediaListObj = ref({});
    const {
      getStatus
    } = useMedia();
    const availableFiles = inject('availableFiles');
    const tab2DialogRef = ref();
    const approvalStatusTip = computed(() => {
      const approval = getStatus(props.data.userInfo.AuditStatus);
      return approval?.tip;
    });
    const approvalStatusAlias = computed(() => {
      const approval = getStatus(props.data.userInfo.AuditStatus);
      return approval?.alias || approval?.label || '温馨提示：';
    });
    const clickBatchSetting = () => {
      tab2DialogRef.value.openDialog();
    };
    const handleSure = (list, file) => {
      if (!file) {
        availableFiles.value.forEach(item => {
          if (props.data.label == '臻选媒体') {
            item.selectedMediaIds = list.map(i => i.itemID);
          } else if (props.data.label == '自媒体') {
            item.selfMediaIds = list.map(i => i.itemID);
          }
        });
      } else if (props.data.label == '臻选媒体') {
        file.selectedMediaIds = list.map(i => i.itemID);
      } else if (props.data.label == '自媒体') {
        file.selfMediaIds = list.map(i => i.itemID);
      }
    };
    const clickEdit = file => {
      tab2DialogRef.value.openDialog(file);
    };
    onMounted(async () => {
      const postData = {
        itemType: props.data.value
      };
      try {
        if (props.data.label == '臻选媒体') {
          const e = await getOrdinaryMediaType(postData);
          // e.data.unshift(e.recommend)
          mediaOptions.value = e.data;
          mediaOptions.value.forEach(item => {
            item.child.forEach(citem => {
              mediaListObj.value[citem.itemID] = citem;
            });
          });
        } else if (props.data.label == '自媒体') {
          const e = await getSelfMediaType(postData);
          // e.data.unshift(e.recommend)
          mediaOptions.value = e.data;
          mediaOptions.value.forEach(item => {
            item.child.forEach(citem => {
              mediaListObj.value[citem.itemID] = citem;
            });
          });
        }
      } catch (e) {
        // 处理错误
      }
    });
    const handleClose = (file, item) => {
      if (props.data.label == '臻选媒体') {
        file.selectedMediaIds = file.selectedMediaIds.filter(i => i != item);
      } else if (props.data.label == '自媒体') {
        file.selfMediaIds = file.selfMediaIds.filter(i => i != item);
      }
    };
    const handleRenderData = data => {
      return {
        type: 'card',
        title: data.title,
        content: data.content
      };
    };
    __expose({
      useCount
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createTextVNode(_toDisplayString(approvalStatusAlias.value) + "： ", 1), _createElementVNode("span", null, _toDisplayString(approvalStatusTip.value), 1)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "text-[#1D2129] font-medium"
      }, "设置发布媒体"), _createElementVNode("div", {
        class: "text-[#86909C]"
      }, "单平台发布消耗20点权益")], -1)), _createVNode(_component_el_button, {
        type: "text",
        onClick: clickBatchSetting
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("批量设置媒体", -1)]))]),
        _: 1
      })]), _createVNode(_component_el_row, {
        class: "pl-4 pr-4 pb-4",
        gutter: 12
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFiles), (file, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            class: "mt-2 relative",
            key: index,
            span: 8
          }, {
            default: _withCtx(() => [file.bannedWords ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(ArticleHandle, {
              data: file,
              onRefresh: _cache[0] || (_cache[0] = $event => emits('refresh'))
            }, null, 8, ["data"])])) : _createCommentVNode("", true), _createVNode(_component_el_popover, {
              placement: "bottom",
              width: 400,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [_createVNode(DraggableWrapper, {
                renderData: handleRenderData(file)
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(file.fileTitle), 1), _createVNode(_component_el_icon, {
                  color: "#333",
                  class: "cursor-pointer text-[16px] align-middle",
                  onClick: $event => clickEdit(file)
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Edit))]),
                  _: 1
                }, 8, ["onClick"]), props.data.label == '臻选媒体' ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 本次发布" + _toDisplayString(file?.selectedMediaIds?.length || 0) + "个平台，预计" + _toDisplayString(file?.selectedMediaIds?.length * 20 || 0) + "点 ", 1)) : _createCommentVNode("", true), props.data.label == '自媒体' ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 本次发布" + _toDisplayString(file?.selfMediaIds?.length || 0) + "个平台，预计" + _toDisplayString(file?.selfMediaIds?.length * 20 || 0) + "点 ", 1)) : _createCommentVNode("", true)]), props.data.label == '臻选媒体' && file?.selectedMediaIds?.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.selectedMediaIds, (item, cindex) => {
                  return _openBlock(), _createBlock(_component_el_tag, {
                    key: cindex,
                    closable: "",
                    onClose: $event => handleClose(file, item)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(mediaListObj.value[item]?.title), 1)]),
                    _: 2
                  }, 1032, ["onClose"]);
                }), 128))])) : _createCommentVNode("", true), props.data.label == '自媒体' && file?.selfMediaIds?.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.selfMediaIds, (item, cindex) => {
                  return _openBlock(), _createBlock(_component_el_tag, {
                    key: cindex,
                    closable: "",
                    onClose: $event => handleClose(file, item)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(mediaListObj.value[item]?.title), 1)]),
                    _: 2
                  }, 1032, ["onClose"]);
                }), 128))])) : _createCommentVNode("", true)])]),
                _: 2
              }, 1032, ["renderData"])]),
              default: _withCtx(() => [props.data.label == '臻选媒体' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.selectedMediaIds, (item, cindex) => {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: cindex,
                  closable: "",
                  onClose: $event => handleClose(file, item)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(mediaListObj.value[item]?.title), 1)]),
                  _: 2
                }, 1032, ["onClose"]);
              }), 128)), !file?.selectedMediaIds?.length ? (_openBlock(), _createElementBlock("span", _hoisted_13, "请选择要发布的媒体")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), props.data.label == '自媒体' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.selfMediaIds, (item, cindex) => {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: cindex,
                  closable: "",
                  onClose: $event => handleClose(file, item)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(mediaListObj.value[item]?.title), 1)]),
                  _: 2
                }, 1032, ["onClose"]);
              }), 128)), !file?.selfMediaIds?.length ? (_openBlock(), _createElementBlock("span", _hoisted_15, "请选择要发布的媒体")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_17, "预计消耗权益点：" + _toDisplayString(useCount.value) + "点", 1), _createTextVNode(" （当前可用点数：" + _toDisplayString(_unref(appStore).surplusNum) + "点） ", 1)])]), _createVNode(Tab2Dialog, {
        ref_key: "tab2DialogRef",
        ref: tab2DialogRef,
        mediaOptions: mediaOptions.value,
        type: props.data.label,
        onClickSure: handleSure
      }, null, 8, ["mediaOptions", "type"]), _createVNode(_component_el_popover, {
        trigger: "hover",
        "virtual-ref": "yourVirtualRef",
        "virtual-triggering": ""
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("test123", -1)]))]),
        _: 1
      })]);
    };
  }
});